<div class="container">
    <a href="#" class="logo" @click.prevent="logoClick" aria-label="logo">
        <icon name="logo" />
    </a>
    <slot name="rightMenu" />
</div>
